import { AuthProviderProps } from 'react-oidc-context';

// OIDC configuration
export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI,

  // Standard scopes for OpenID Connect
  scope: 'openid profile email',

  // Automatically renew the token before it expires
  automaticSilentRenew: true,

  // Load user info from the userinfo endpoint after login
  loadUserInfo: true,

  // Response type for authorization code flow
  response_type: 'code',

  // Additional options
  onSigninCallback: () => {
    // Remove the query parameters from the URL after login
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    );
  },
};